<template>
  <form v-if="!isLoading && ticket">
    <md-card>
      <md-card-header data-background-color="primary">
        <h4 class="title">Visualizar chamado</h4>
        <p class="category">Chamado #{{ ticket.id }}</p>
      </md-card-header>

      <md-card-content>
        <h4 class="title">Dados Pessoais</h4>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Protocolo</label>
              <md-input disabled :value="ticket.protocol"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Tipo de Atendimento</label>
              <md-input
                disabled
                :value="formatTicketType(ticket.type)"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Usuário</label>
              <md-input disabled :value="ticket.clientName"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Data</label>
              <md-input disabled :value="date"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Hora</label>
              <md-input disabled :value="time"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Nome do Solicitante</label>
              <md-input disabled :value="ticket.name"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Relação com Assinante:</label>
              <md-input
                disabled
                :value="formatRelationship(ticket.relationship)"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>E-mail</label>
              <md-input disabled :value="ticket.email || 'N/D'"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Telefone</label>
              <md-input disabled :value="ticket.phone || 'N/D'"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Descrição do problema</label>
              <md-textarea disabled :value="ticket.description"></md-textarea>
            </md-field>
          </div>

          <div class="md-layout-item md-size-100 text-right">
            <router-link to="/tickets">
              <md-button class="md-raised btn">
                Voltar
              </md-button>
            </router-link>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import { format } from "date-fns";
import { formatTicketType, formatRelationship } from "@/helpers";
export default {
  name: "ticket-form",
  computed: {
    ticket() {
      return this.$store.getters.ticket;
    },
    date() {
      const d = new Date(this.ticket.createdAt);
      d.setHours(d.getHours() + 3);
      return this.ticket && format(new Date(d), "dd/MM/yyyy");
    },
    time() {
      const d = new Date(this.ticket.createdAt);
      d.setHours(d.getHours() + 3);
      return this.ticket && format(new Date(d), "HH:mm");
    }
  },
  data() {
    return {
      isLoading: true
    };
  },
  methods: {
    ...mapActions(["fetchTicket"]),
    formatTicketType,
    formatRelationship
  },
  async mounted() {
    const loader = this.$loading.show({
      color: "#A9CD84",
      lockScroll: true,
      container: this.$refs.formContainer,
      canCancel: false
    });
    try {
      await this.fetchTicket({ id: this.$route.params.id });
    } catch (err) {
      if (err.response) {
        if (err.response.status === 404) {
          Swal.fire("Ops!", "Chamado não encontrado.", "error");
        } else if (err.response.status === 403) {
          Swal.fire(
            "Ops!",
            "Você não tem permissão de ver este chamado.",
            "error"
          );
        } else {
          Swal.fire(
            "Ops!",
            "Houve algum problema ao buscar o chamado.",
            "error"
          );
        }
      } else {
        Swal.fire("Ops!", "Não foi possível conectar com o servidor.", "error");
      }
    } finally {
      this.isLoading = false;
      loader.hide();
    }
  }
};
</script>

<style scoped>
.btn {
  background-color: var(--primary-color) !important;
}
.btn:hover {
  background-color: var(--secondary-color) !important;
}
</style>
